import slider from './slider';
import fullscreen from './fullscreen';
import transition from './transition';
import hover from './hover';
import scroll from './scroll';

export default class sceneManager {
    constructor(manager) {

        //manager
        this.manager = manager;
        this.hover = new hover(this.manager,this); //一覧のホバー動作
        this.fullscreen = new fullscreen(this.manager,this); //フルスクーン（詳細）ー動作
        this.slider = new slider(this.manager,this); //スライダー動作
        this.transition = new transition(this.manager,this); //ページ遷移動作
        this.scroll = new scroll(this.manager,this); //ページタイトル消す

        //dom
        //一覧
        this.$title = document.getElementById('l-lowlayer__title');
        this.$wrap = document.getElementById('p-scene');
        this.$coverList = document.querySelectorAll('.js__scene-list .cover');
        this.$scrollList = document.querySelectorAll('.js__scene-list');
        //詳細
        this.$slide = document.getElementById("p-scene__slide");
        this.$slideList = document.querySelectorAll(".js__scene-slide");
        this.$controlList = document.querySelectorAll(' #p-scene__control>ul>li');
        this.$prev = document.getElementById('p-scene__control-prev');
        this.$next = document.getElementById('p-scene__control-next');
        //header
        this.$headerNavi = document.getElementById("l-header__navi");

        //status
        this.status = {
            mode:'scroll',
            absolutePosiX:0,
            absolutePosiY:0,
            posiY:0,
            current:0,
            next:0,
            max:this.$scrollList.length-1,
            motion:false,
            titlePoint:0,
            titleFlg:false,
        }

        if (this.manager.status.pageID === "scene-living") {
            this.logoColor = ['black','white','black','white','black','white','white','white','white','white']
            this.snsColor = ['black','white','black','white','black','white','white','white','white','white']
            this.footerColor = ['black','white','black','white','black','white','white','white','white','white']
            this.menuColor = ['black','white','black','white','black','white','white','white','white','white']
        } else {
            this.logoColor = ['black','white','black','white','white','white','black','black']
            this.snsColor = ['black','white','black','white','white','white','black','black']
            this.footerColor = ['black','white','black','white','white','white','black','black']
            this.menuColor = ['black','white','black','white','white','white','black','black']
        }

        // 全体のボタン関係の色の設定（スライダーによって変更）
        this.colorArray = {
            logoColor: this.logoColor,
            snsColor: this.snsColor,
            footerColor: this.footerColor,
            menuColor: this.menuColor,
            headerOpacity: [0,0,0,0,0,0,0,0]
        };

    }
    init(){

        // ------------ spの時fixedフッターを非表示
        if(this.manager.param.displayType == 'sp'){
            TweenMax.to('#l-footer', .6 ,{
                opacity:0,
                ease: Power2.easeOut,
            });
        }

        //set
        this.manager.scrollIcon.show();
        this.transition.init();
        this.transition.in();
        this.fullscreen.init();
        this.slider.init();
        this.hover.init();

        this.manager.color.set('black','black','black','black',1);

        for(let i in this.$scrollList) { if (this.$scrollList[i].nodeType != 1) continue;

            //click
            this.$scrollList[i].addEventListener("click",()=>{
                if(this.status.motion) return;
                this.status.motion = true;
                this.status.current = i;
                this.status.next = this.status.current;
                this.fullscreen.show();
                // ------------ 全画面表示時はHeaderを必ず非表示
                TweenMax.to(this.$headerNavi, .6 ,{
                    opacity:0,
                    ease: Power2.easeOut,
                });
            });

        }

        this.$slide.addEventListener("click",()=>{
            if(this.status.motion) return;
            this.status.motion = true;
            this.fullscreen.hide();
        });

    }
    render(mouse,scrollInc){

        if(this.$title) this.scroll.renderIndex();

    }
    resize(){

        this.fullscreen.resize();
        if(this.$title) this.scroll.resizeIndex();
    }
}